import { MenuStates } from '@frontend-site/main-header/domain';
import { RDX_ROUTES } from './rdx-routes';
import { SYSTEM_ROUTES } from './system-routes';
import { SYSTEM_SETUP_ROUTES } from './system-setup-routes';
import { REPORTS_ROUTES } from './reports-routes';
import { TM_ROUTES } from './tm-routes';
import { OLD_UI_REDIRECT_ROUTES } from './old-ui-redirect-routes';
import { LastPageResolver } from './last-page.resolver';
import { ProjectResolver, RdxResolver } from '@frontend-site/shared/core';
import { EnterProjectComponent, ProjectLandingPageComponent } from '@frontend-site/project/features';
import { PanayaRoutes } from '@frontend-site/shared/router-store';
import { LoopbackComponent } from '@frontend-site/shared/hybrid';
import { SettingsResolver } from '@modules/settings/settings.resolver';
import { AiConsentToProjectGuard } from '../guards/ai-consent-project.guard';
import { IssuesGuard } from '../guards/issues-guard.service';
import { PendingChangesGuard } from '@common/guards/pending-changes.guard';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ProjectDetailsResolver } from '../../../panaya-temp/src/modules/overview/project-details/project-details.resolver';

export const routes: PanayaRoutes = [
    { path: '', resolve: { _: LastPageResolver }, pathMatch: 'full', children: [] },
    { path: 'project', component: LoopbackComponent, data: { navState: 'main', menuState: MenuStates.ALL_PROJECTS, rememberMe: true } },
    { path: 'login', component: LoopbackComponent, data: { navState: 'login' } },
    { path: 'enterProject/:projectId/:projectType/:systemId', component: EnterProjectComponent },
    { path: 'enterRelease/:companyId/:id', component: LoopbackComponent, data: { navState: 'enterRelease' } },
    { path: 'enterSystem/:id', component: LoopbackComponent, data: { navState: 'enterSystem' } },
    {
        path: 'systems',
        component: LoopbackComponent,
        data: { navState: 'systemsList', menuState: MenuStates.ALL_PROJECTS, rememberMe: true }
    },
    { path: 'enterSystem/:id', component: LoopbackComponent, data: { navState: 'enterSystem' } },
    { path: 'project-selector/discovery', component: LoopbackComponent, data: { navState: 'project-selector.discovery' } },
    ...OLD_UI_REDIRECT_ROUTES,
    ...TM_ROUTES,
    REPORTS_ROUTES,
    RDX_ROUTES,
    SYSTEM_SETUP_ROUTES,
    SYSTEM_ROUTES,
    {
        path: 'dashboard',
        children: [
            {
                path: 'projectManager',
                component: LoopbackComponent,
                data: { navState: 'dashboard.projectManager', menuState: MenuStates.ALL_PROJECTS, rememberMe: true }
            }
        ]
    },
    {
        path: 'foresight',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../panaya-temp/src/modules/foresight/foresight.module').then((m) => m.ForesightModule)
    },
    {
        path: 'entry',
        outlet: 'dialog',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../panaya-temp/src/common/entry/entry.module').then((e) => e.EntryModule)
    },
    {
        path: 'settings',
        resolve: { loadSettings: SettingsResolver },
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../panaya-temp/src/modules/settings/settings.module').then((m) => m.SettingsModule)
    },
    {
        path: 'global',
        children: [
            {
                path: ':companyId',
                children: [
                    {
                        path: 'defects',
                        resolve: { loadCompany: RdxResolver },
                        data: { menuState: MenuStates.ALL_PROJECTS },
                        loadChildren: () => import('../../../panaya-temp/src/modules/defects/defects.module').then((m) => m.DefectsModule)
                    }
                ]
            }
        ]
    },
    {
        path: ':projectId',
        resolve: { loadProject: ProjectResolver },
        data: { menuState: MenuStates.PROJECT },
        canActivate: [AiConsentToProjectGuard],
        children: [
            { path: '', component: ProjectLandingPageComponent },
            {
                path: 'corrections',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/corrections/corrections.module').then((m) => m.CorrectionsModule)
            },
            {
                path: 'projectPlan',
                loadChildren: () => import('@modules/project-plan/project-plan.module').then((m) => m.ProjectPlanModule)
            },
            {
                path: 'issues',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () => import('../../../panaya-temp/src/modules/issues/issues.module').then((m) => m.IssuesModule),
                canActivate: [IssuesGuard]
            },
            {
                path: 'defects',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () => import('../../../panaya-temp/src/modules/defects/defects.module').then((m) => m.DefectsModule)
            },
            {
                path: 'system-wide-defects',
                loadChildren: () =>
                    // eslint-disable-next-line @nx/enforce-module-boundaries
                    import('../../../panaya-temp/src/modules/system-wide-defects/system-wide-defects.module').then(
                        (m) => m.SystemWideDefectsModule
                    )
            },
            {
                path: 'development',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/development/development.module').then((m) => m.DevelopmentModule)
            },
            {
                path: 'steps',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () => import('../../../panaya-temp/src/modules/steps/steps.module').then((m) => m.StepsModule)
            },
            {
                path: 'testSets',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () => import('../../../panaya-temp/src/modules/test-sets/test-sets.module').then((m) => m.TestSetsModule)
            },
            {
                path: 'paExecutionScheduling',
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/pa-execution-scheduling/pa-execution-scheduling.module').then(
                        (m) => m.PaExecutionSchedulingModule
                    )
            },
            {
                path: 'paRun',
                loadChildren: () => import('../../../panaya-temp/src/modules/pa-run/pa-run.module').then((m) => m.PaRunModule)
            },
            {
                path: 'paExecution',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/pa-execution/pa-execution.module').then((m) => m.PaExecutionModule)
            },
            {
                path: 'paRunDetailsFromOld',
                loadChildren: () =>
                    // eslint-disable-next-line @nx/enforce-module-boundaries
                    import('../../../panaya-temp/src/modules/pa-run-details-from-old/pa-run-details-from-old.module').then(
                        (m) => m.PaRunDetailsFromOld
                    )
            },
            {
                path: 'requirements',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/development/development.module').then((m) => m.DevelopmentModule)
            },
            {
                path: 'tests',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () => import('../../../panaya-temp/src/modules/tests/tests.module').then((m) => m.TestsModule)
            },
            {
                path: 'globalSearch',
                loadChildren: () => import('@frontend-site/global-search').then((m) => m.GlobalSearchModule)
            },
            {
                path: 'tree',
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/tree-actions/p-tree-actions.module').then((e) => e.PTreeActionsModule)
            },
            {
                path: 'overview/project-details',
                canDeactivate: [PendingChangesGuard],
                providers: [PendingChangesGuard],
                resolve: { projectData: ProjectDetailsResolver },
                // eslint-disable-next-line @nx/enforce-module-boundaries
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/overview/project-details/project-details.module').then(
                        (m) => m.ProjectDetailsModule
                    )
            }
        ]
    },
    { path: '**', redirectTo: '/project', pathMatch: 'full' }
];
